import { createSelector } from 'reselect';
import { getCurrentUser } from '../user/user.selectors';
import find from 'lodash/find';
import orderBy from 'lodash/orderBy';

const allIds = (state) => state.entities.prize.allIds;
const byId = (state) => state.entities.prize.byId;

export const getAllPrizes = createSelector(
  [ byId, allIds ],
  (prizes, ids) => {
    return ids.map(id => prizes[id]);
  }
);

export const getAllPrizesSorted = createSelector(
  [ getAllPrizes ],
  (prizes) => {
    return orderBy(prizes, 'price', 'desc');
  }
);

export const getAllPrizesSortedAsc = createSelector(
  [ getAllPrizes ],
  (prizes) => {
    return orderBy(prizes, 'price', 'asc');
  }
);

export const getSecondaryPrizes = createSelector(
  [ getAllPrizesSorted ],
  (prizes) => {
    return prizes.filter(p => !p.mainPrize);
  }
);

export const getMainPrize = createSelector(
  [getAllPrizes],
  (prizes) => {
    const mainPrizes = prizes.filter(p => p.mainPrize);
    if(mainPrizes.length > 0) {
      return mainPrizes[0];
    }
    return null;
  }
);

//if score > max score needed for main prize, return next closest prize by price
//else return mainPrize
export const getClosestPrizeByScore = createSelector(
  [getAllPrizesSortedAsc, getMainPrize, getCurrentUser],
  (prizes, mainPrize, currentUser) => {
    const { score } = currentUser;
    const nextPrizeByScore = find(prizes, (prize) => {
      return prize.price > score;
    });
    if(nextPrizeByScore) {
      return nextPrizeByScore;
    }
    return mainPrize;
  }
);
/*
export const getFeaturedPrize = createSelector(
  [getAllPrizes],
  (prizes) => {
    const featuredPrizes = prizes.filter(p => p.featuredPrize);
    if(featuredPrizes.length > 0) {
      return featuredPrizes[0];
    }
    return null;
  }
);
*/


// WEBPACK FOOTER //
// ./src/modules/prize/prize.selectors.js